export const MuiFormControlLabelTheme = () => {
    return {
        styleOverrides: {
            root: {
                marginLeft: 0,
                marginRight: 0,
                "&.Mui-disabled": {
                    pointerEvents: "none",
                },
            },
        },
    };
};
